import React from 'react';
import { CTAButton } from './CTAButton';
const metrics = [{
  value: '5',
  label: 'Volumi completi'
}, {
  value: '4',
  label: 'Bonus professionali'
}, {
  value: '504',
  label: 'Pagine già organizzate, così non devi cercarle una alla volta'
}, {
  value: '🇮🇹',
  label: 'Pensato per i docenti di chimica in Italia'
}];
export function Hero() {
  return <section className="w-full bg-paper px-5 pb-6 pt-6 sm:pb-12 sm:pt-10" data-id="element-114" data-mp="4jm7tt5w3bt7">
      <div className="mx-auto flex max-w-3xl flex-col items-center text-center" data-id="element-115" data-mp="128z0cez35zzp">
        <span className="mb-4 inline-block rounded-full border border-cobalt bg-cobalt/10 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-wider text-cobalt-deep sm:mb-6" data-id="element-116" data-mp="xbfi73z9p32h">
          RISORSE DIGITALI PRONTE ALL'USO PER INSEGNARE CHIMICA
        </span>

        <h1 className="font-serif-display text-[26px] font-bold leading-tight text-ink sm:text-5xl md:text-6xl" data-id="element-117" data-mp="3d1a7phvug7c8">
          Ogni settimana perdi ore a cercare materiali di chimica online?
        </h1>
        
        <p className="mt-3 text-base font-medium text-cobalt-deep sm:mt-5 sm:text-xl" data-id="element-118" data-mp="3j7zf9iqmlsgo">
          Puoi avere il tuo percorso didattico di chimica già organizzato e pronto da usare in meno di 5 minuti.
        </p>

        <figure className="relative mt-5 w-full max-w-[680px] sm:mt-8" data-id="element-119" data-mp="39b4gcyqfxq1v">
          <div className="relative overflow-hidden rounded-[20px] bg-paper shadow-[0_20px_45px_-22px_rgba(31,36,48,0.28)] sm:rounded-[26px]" data-id="element-120" data-mp="3e9fuvmrokoqf">
            <img src="https://cdn.magicpatterns.com/uploads/hGfysRVerdpNzfkhhfANVy/MOCKUP_QUIMICA_EN_ITALIANO.png" alt="Docente di chimica con la raccolta CHIMICA VISIVA™ e i cinque volumi del sistema didattico" width="1365" height="768" loading="eager" decoding="async" sizes="(max-width: 680px) calc(100vw - 40px), 680px" className="block aspect-[16/9] w-full object-cover" data-id="element-121" data-mp="30h9cdu1225nt" />
            <div className="pointer-events-none absolute inset-0 rounded-[20px] ring-1 ring-inset ring-white/45 sm:rounded-[26px]" aria-hidden="true" data-id="element-122" data-mp="2ljgzl9mw7vdb" />
          </div>
        </figure>

        <p className="mt-5 max-w-xl text-[13px] leading-relaxed text-ink/75 sm:mt-6 sm:text-base" data-id="element-123" data-mp="n98crlqgh1mu">
          CHIMICA VISIVA™ riunisce teoria visiva, attività, schede, verifiche e soluzioni in un unico sistema digitale pronto all'uso.
        </p>

        <div className="mt-6 w-full max-w-md sm:mt-8" data-id="element-124" data-mp="1b1fd0vzaxsrj">
          <CTAButton label="OTTIENI CHIMICA VISIVA™ ORA" data-id="element-125" data-mp="1ayt7f1vz1nby" />
          <p className="mt-2.5 text-xs text-ink/60 sm:text-sm" data-id="element-126" data-mp="162ugp7n67t8d">
            Pagamento unico · Nessun abbonamento · Accesso immediato
          </p>
        </div>

        <div className="mt-6 grid w-full grid-cols-2 overflow-hidden rounded-2xl border border-cobalt/30 bg-white sm:mt-8 sm:grid-cols-4" data-id="element-127" data-mp="x14npxdn4m8h">
          {metrics.map((metric, index) => <div key={metric.label} className={`flex flex-col items-center px-4 py-4 sm:py-6 ${index % 2 !== 0 ? 'border-l border-cobalt/20' : ''} ${index >= 2 ? 'border-t border-cobalt/20' : ''} sm:border-l sm:border-t-0 sm:first:border-l-0`} data-id="element-128" data-mp="3lqm2xztl37vg" data-mpi={index}>
              <span className="font-serif-display text-3xl font-bold text-cobalt sm:text-4xl" data-id="element-129" data-mp="26a98hgz9d4u3">
                {metric.value}
              </span>
              <span className="mt-1 text-[11px] font-medium leading-snug text-ink sm:text-sm" data-id="element-130" data-mp="2b2aisxcv8lhh">{metric.label}</span>
            </div>)}
        </div>
      </div>
    </section>;
}